import gql from 'graphql-tag'

import { MutationFunction } from 'react-apollo'
import {
  UpdateGatheringRegistration,
  UpdateGatheringRegistrationVariables,
} from './__generated__/UpdateGatheringRegistration'

export const UPDATE_GATHERING_REGISTRATION_MUTATION = gql`
  mutation UpdateGatheringRegistration(
    $gatheringRegistrationId: Int!
    $gatheringRegistration: GatheringRegistrationParams!
  ) {
    updateGatheringRegistration(
      gatheringRegistrationId: $gatheringRegistrationId
      gatheringRegistration: $gatheringRegistration
    ) {
      id
      quantity
    }
  }
`

export type UpdateGatheringRegistrationMutationFn = MutationFunction<
  UpdateGatheringRegistration,
  UpdateGatheringRegistrationVariables
>
